import React from 'react';
interface SubSectionProps {
  id: string;
  title: string;
  children: React.ReactNode;
}
const SubSection: React.FC<SubSectionProps> = ({
  id,
  title,
  children
}) => {
  return <div id={id} className="mt-8 mb-6" data-id="element-126">
      <h3 className="text-2xl font-semibold text-gray-900 mb-4" data-id="element-127">{title}</h3>
      <div data-id="element-128">{children}</div>
    </div>;
};
export default SubSection;